/* INTEGY V250 — Cars & Trucks title-name filters (RTR / ARTR / Kit) — 14JUN2026
   Uses title text instead of product tags so broad vehicle collections are not dependent on scale/tag filtering. */
(function(){
  'use strict';
  if (window.INTEGY_V250_CARS_TRUCKS_TITLE_FILTERS_LOADED) return;
  window.INTEGY_V250_CARS_TRUCKS_TITLE_FILTERS_LOADED = true;

  var docEl = document.documentElement;
  docEl.classList.add('integy-v250-title-filters');
  if (!/^\/collections\//.test(location.pathname || '')) return;

  var TITLE_FILTER_COLLECTIONS = {
    'cars-trucks': 1,
    '1-10-and-1-12-rc-vehicles': 1,
    '1-18-and-1-24-rc-vehicles': 1,
    '1-14-1-18-1-24-off-road-rtr-parts': 1,
    'all-terrain-off-road-vehicles': 1
  };

  var MODES = [
    { key: 'rtr',  label: 'RTR',  re: /\bRTR\b/i },
    { key: 'artr', label: 'ARTR', re: /\bARTR\b/i },
    { key: 'kit',  label: 'Kit',  re: /\bKIT\b/i }
  ];

  var cache = null;
  var cachePromise = null;

  function qs(s,r){try{return(r||document).querySelector(s)}catch(e){return null}}
  function qsa(s,r){try{return Array.prototype.slice.call((r||document).querySelectorAll(s))}catch(e){return[]}}
  function clean(s){return String(s == null ? '' : s).replace(/\s+/g,' ').trim()}
  function handleize(v){v=String(v||'').toLowerCase();try{v=v.normalize('NFKD').replace(/[\u0300-\u036f]/g,'')}catch(e){}return v.replace(/&/g,' and ').replace(/[’']/g,'').replace(/[^a-z0-9]+/g,'-').replace(/-+/g,'-').replace(/^-|-$/g,'')}
  function parts(){return (location.pathname||'').split('/').filter(Boolean)}
  function currentHandle(){var p=parts(),i=p.indexOf('collections');return i>=0&&p[i+1]?handleize(decodeURIComponent(p[i+1])):''}
  function basePath(){var p=parts(),i=p.indexOf('collections');return i>=0&&p[i+1]?'/'+p.slice(0,i+2).join('/'):''}
  function modeFromUrl(){try{return handleize(new URLSearchParams(location.search||'').get('integy_vehicle_filter')||'')}catch(e){return''}}
  function modeDef(key){for(var i=0;i<MODES.length;i++){if(MODES[i].key===key)return MODES[i]}return null}
  function productCount(){var main=qs('main')||document.body, txt=clean(main.textContent||'');var m=txt.match(/(?:^|\s)([\d,]+)\s+products?(?:\s|$)/i);return m?(parseInt(m[1].replace(/,/g,''),10)||0):0}
  function grid(){return qs('[data-productgrid-items],.productgrid--items')}
  function cardsIn(doc){return qsa('[data-productgrid-items] .productgrid--item,.productgrid--items .productgrid--item', doc)}
  function cardTitle(card){var t=qs('.productitem--title',card);return clean((t||card).textContent||'')}
  function cardUrl(card){var a=qs('.productitem--title a,[data-product-page-link],a[href*="/products/"]',card);return a?String(a.getAttribute('href')||''):''}
  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}

  function maxPage(){
    var max=1;
    qsa('a[href*="page="]').forEach(function(a){
      try{var u=new URL(a.href,location.origin),n=parseInt(u.searchParams.get('page')||'',10);if(n>max)max=n;}catch(e){}
    });
    if(max<2){
      var total=productCount(), per=cardsIn(document).length || 56;
      if(total && per) max=Math.max(max, Math.ceil(total/per));
    }
    return Math.min(Math.max(max,1),12);
  }

  function pageUrl(n){
    var u=new URL(basePath(), location.origin);
    try{
      var cur=new URLSearchParams(location.search||'');
      cur.delete('integy_vehicle_filter');
      cur.delete('page');
      cur.delete('view');
      cur.delete('grid_list');
      cur.forEach(function(v,k){if(v!=null&&v!=='')u.searchParams.set(k,v)});
    }catch(e){}
    if(n>1)u.searchParams.set('page',String(n));
    return u.toString();
  }

  function fetchPage(n){
    if(n===1) return Promise.resolve(document.documentElement.outerHTML);
    return fetch(pageUrl(n),{credentials:'same-origin',cache:'force-cache',headers:{Accept:'text/html'}}).then(function(r){return r.ok?r.text():''}).catch(function(){return''});
  }

  function collectProducts(){
    if(cache) return Promise.resolve(cache);
    if(cachePromise) return cachePromise;
    var pages=[];
    for(var i=1,n=maxPage();i<=n;i++) pages.push(i);
    cachePromise=Promise.all(pages.map(fetchPage)).then(function(htmls){
      var parser=new DOMParser(), seen=Object.create(null), out=[];
      htmls.forEach(function(html){
        if(!html) return;
        var doc=parser.parseFromString(html,'text/html');
        cardsIn(doc).forEach(function(card){
          var url=cardUrl(card), title=cardTitle(card);
          var key=url || title;
          if(!key || seen[key]) return;
          seen[key]=1;
          out.push({title:title,url:url,html:card.outerHTML});
        });
      });
      cache=out;
      return out;
    }).catch(function(){cache=cardsIn(document).map(function(card){return{title:cardTitle(card),url:cardUrl(card),html:card.outerHTML}});return cache;});
    return cachePromise;
  }

  function countsFor(items){
    var counts={rtr:0,artr:0,kit:0};
    (items||[]).forEach(function(item){
      MODES.forEach(function(m){if(m.re.test(item.title||'')) counts[m.key]++;});
    });
    return counts;
  }

  function filterUrl(key){
    var u=new URL(basePath(), location.origin);
    try{
      var cur=new URLSearchParams(location.search||'');
      cur.delete('page');cur.delete('view');cur.delete('grid_list');cur.delete('integy_vehicle_filter');
      cur.forEach(function(v,k){if(v!=null&&v!=='')u.searchParams.set(k,v)});
    }catch(e){}
    if(key) u.searchParams.set('integy_vehicle_filter', key);
    return u.pathname + (u.search ? u.search : '');
  }

  function listNodes(){return qsa('[data-integy-v250-title-mode-list],[data-integy-v200-static-part-filter-list],.integy-v200-static-part-filter-list,.integy-v201-static-part-filter-list')}
  function makeRow(m,active,count){
    var a=document.createElement('a');
    a.className='integy-v27-filter-chip integy-v31-checkbox-filter integy-v201-static-filter-row integy-v218-static-filter-row integy-v239-filter-row integy-v247-filter-row integy-v250-title-mode-row'+(active?' is-active integy-v31-checkbox-filter--active':'');
    a.href=filterUrl(active?'':m.key);
    a.setAttribute('role','checkbox');
    a.setAttribute('aria-checked',active?'true':'false');
    a.setAttribute('data-integy-v250-title-filter',m.key);
    a.setAttribute('data-integy-v247-direct-nav','true');
    a.innerHTML='<span class="integy-v201-filter-box integy-v200-filter-box" aria-hidden="true"></span><span class="integy-v201-filter-label"></span><span class="integy-v201-filter-count"></span>';
    qs('.integy-v201-filter-label',a).textContent=m.label;
    qs('.integy-v201-filter-count',a).textContent=(typeof count==='number')?'('+Number(count).toLocaleString()+')':'';
    return a;
  }

  function renderSidebar(counts){
    var ch=currentHandle();
    if(!TITLE_FILTER_COLLECTIONS[ch]) return;
    var active=modeFromUrl(), sb=qs('.productgrid--sidebar,[data-productgrid-sidebar]');
    docEl.classList.add('integy-v250-title-filter-active');
    qsa('.integy-sidebar-helper',sb||document).forEach(function(el){el.textContent='Use RTR, ARTR, or Kit to narrow this vehicle collection by product title.'});
    qsa('.integy-v200-static-part-filter-details summary span:first-child,.integy-v249-scale-only-details summary span:first-child,.integy-v250-title-mode-details summary span:first-child',sb||document).forEach(function(el){el.textContent='Vehicle Type'});
    qsa('.productgrid--sidebar input[type="search"],.productgrid--sidebar input[type="text"],[data-productgrid-sidebar] input[type="search"],[data-productgrid-sidebar] input[type="text"]').forEach(function(input){
      var ph=(input.getAttribute('placeholder')||'').toLowerCase();
      if(ph.indexOf('filter')>-1 || ph.indexOf('find')>-1 || ph.indexOf('scale')>-1) input.setAttribute('placeholder','Find type...');
    });
    listNodes().forEach(function(list){
      var frag=document.createDocumentFragment();
      MODES.forEach(function(m){frag.appendChild(makeRow(m,active===m.key,counts?counts[m.key]:undefined));});
      list.innerHTML='';
      list.appendChild(frag);
      list.setAttribute('data-integy-v250-rendered-title-mode','true');
    });
    renderSidebarActive(active);
  }

  function renderSidebarActive(active){
    var sb=qs('.productgrid--sidebar,[data-productgrid-sidebar]');
    if(!sb) return;
    var old=qs('[data-integy-v250-active-box]',sb);if(old)old.remove();
    var def=modeDef(active); if(!def) return;
    var title=qs('.integy-sidebar-title',sb)||qs('.productgrid--sidebar-title',sb)||sb.firstElementChild;
    var box=document.createElement('div');
    box.className='integy-v27-active-filter-box integy-v250-active-filter-box';
    box.setAttribute('data-integy-v250-active-box','true');
    box.innerHTML='<span class="integy-v27-active-filter-label">Active filters</span><a class="integy-v27-active-filter-pill" href="'+esc(filterUrl(''))+'">'+esc(def.label)+' <span aria-hidden="true">×</span></a><a class="integy-v27-clear-filters integy-v31-clear-filters integy-v87-clear-all-filters" href="'+esc(basePath())+'">Clear all filters</a>';
    if(title && title.parentNode) title.parentNode.insertBefore(box, title.nextSibling);
    else sb.insertBefore(box,sb.firstChild);
  }

  function renderGrid(items,mode){
    var def=modeDef(mode), g=grid(); if(!def||!g) return;
    var matches=(items||[]).filter(function(item){return def.re.test(item.title||'')});
    var html='';
    matches.forEach(function(item){html+=item.html});
    if(!html) html='<div class="productgrid--no-results integy-v250-no-results"><h2 class="productgrid--no-results-title">No '+esc(def.label)+' products found in this collection.</h2><a class="productgrid--no-results-button" href="'+esc(basePath())+'">View all products in this collection</a></div>';
    g.innerHTML=html;
    qsa('.pagination--container').forEach(function(p){p.style.display='none'});
    var status=qs('[data-integy-v250-grid-status]');
    if(!status){status=document.createElement('div');status.className='integy-v250-grid-status';status.setAttribute('data-integy-v250-grid-status','true');var outer=qs('.productgrid--items')||g;if(outer&&outer.parentNode)outer.parentNode.insertBefore(status,outer);}
    status.innerHTML='Showing <strong>'+Number(matches.length).toLocaleString()+'</strong> products matching <strong>'+esc(def.label)+'</strong> by title. <a href="'+esc(basePath())+'">Clear filter</a>';
    try{document.dispatchEvent(new CustomEvent('integy:v250:title-filtered',{detail:{mode:mode,count:matches.length}}));}catch(e){}
  }

  function bindClicks(){
    document.addEventListener('click',function(e){
      var a=e.target&&e.target.closest&&e.target.closest('a[data-integy-v250-title-filter]');
      if(!a||!a.href||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey) return;
      e.preventDefault();
      docEl.classList.add('integy-v247-filter-clicking');
      try{location.assign(a.href)}catch(err){location.href=a.href}
    },true);
  }

  function boot(){
    var ch=currentHandle();
    if(!TITLE_FILTER_COLLECTIONS[ch]) return;
    renderSidebar(null);
    collectProducts().then(function(items){
      var counts=countsFor(items);
      renderSidebar(counts);
      var active=modeFromUrl();
      if(modeDef(active)) renderGrid(items,active);
    });
  }

  bindClicks();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  window.addEventListener('pageshow',function(){setTimeout(boot,80)},{passive:true});
  window.addEventListener('load',function(){[200,800,1800,3600].forEach(function(ms){setTimeout(boot,ms)})},{passive:true});
  try{new MutationObserver(function(muts){var ch=currentHandle();if(!TITLE_FILTER_COLLECTIONS[ch])return;for(var i=0;i<muts.length;i++){var t=muts[i].target;if(t&&t.closest&&t.closest('.productgrid--sidebar,[data-productgrid-sidebar]')){setTimeout(function(){renderSidebar(cache?countsFor(cache):null)},30);return;}}}).observe(document.body||document.documentElement,{childList:true,subtree:true});}catch(e){}
})();
